import {
    ApiListType, ArenaGamesGridConfiguration,
    SwiperGamesListConfiguration
} from "../../../configurations/config-data-sections/arenas.configuration";
import {IGamesListModel} from "./games-list-model.interface";
import {RecentlyPlayedListModel} from "./recently-played/recently-played-list.model";
import {TopPicksListModel} from "./top-picks/top-picks-list.model";
import {NewGamesListModel} from "./new-games/new-games-list.model";
import {PlayersLikeYouListModel} from "./players-like-you/players-like-you-list.model";
import {StaticSwiperListModel} from "./static-swiper/static-swiper-list.model";
import {IArenaToGamesListAdapter} from "../arenas/arena-to-games-list-adapter.interface";
import {GamesGridListModel} from "./games-grid/games-grid-list.model";
import { BecauseYouPlayedPlayedListModel } from "./because-you-played/because-you-played-list.model";
import {LiveStreamingVideoListModel} from "./video-list/live-streaming-video-list.model";
import {StaticVideoListModel} from "./video-list/static-video-list.model";


export class ListFactory {

    constructor(private readonly arena: IArenaToGamesListAdapter) {
    }
    createSwiper(swiperConfig: SwiperGamesListConfiguration): IGamesListModel {

        switch (swiperConfig.apiListType) {
            case ApiListType.RECENTLY_PLAYED:
                return new RecentlyPlayedListModel(swiperConfig, this.arena);
            case ApiListType.TOP_PICKS:
                return new TopPicksListModel(swiperConfig, this.arena);
            case ApiListType.NEW_GAMES:
                return new NewGamesListModel(swiperConfig, this.arena);
            case ApiListType.PLAYERS_LIKE_YOU:
                return new PlayersLikeYouListModel(swiperConfig, this.arena);
            case ApiListType.LIVE_CASINO_VIDEO: // maybe rename this to LIVE_STREAMING_VIDEO,but it'd also need admin updated
                return new LiveStreamingVideoListModel(swiperConfig, this.arena);
             case ApiListType.STATIC_VIDEO:
                 return new StaticVideoListModel(swiperConfig, this.arena);
            case ApiListType.BECAUSE_YOU_PLAYED:
                return new BecauseYouPlayedPlayedListModel(swiperConfig, this.arena);

            default:
                return new StaticSwiperListModel(swiperConfig, this.arena);

        }
    }

    createGrid(gridConfig: ArenaGamesGridConfiguration) {
        return new GamesGridListModel(gridConfig, this.arena);
    }
}
